
import { startSessionHelper } from '../utils/startSessionHelper';

export default {
  methods: {
    startSession(initialAuth) {
      startSessionHelper(initialAuth, this.$store);
    }
  }
}
